

export const showMessage = (toast: any, message: string, type: any, options?: {}) => {
    toast.current.show({ severity: type, summary: type, detail: message, life: 3000, ...options });
}
